import { render, staticRenderFns } from "./HapticFeedback.vue?vue&type=template&id=6b9350aa&"
import script from "./HapticFeedback.vue?vue&type=script&lang=ts&"
export * from "./HapticFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports